import { HttpErrorResponse } from '@angular/common/http';
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import { BehaviorSubject } from 'rxjs';
import { take } from 'rxjs/operators';
import { CabecalhoDTO } from 'src/app/entity/dto/cabecalho.component';
import { EnumForm } from 'src/app/entity/enum/enum-form';
import { EnumFormType } from 'src/app/entity/enum/enum-form-type';
import { FormCd001Limpeza } from 'src/app/entity/forms/form-cd001-limpeza';
import { FormularioService } from 'src/app/services/formulario.service';
import { GeneralService } from 'src/app/services/general.service';
import { NotificationService } from 'src/app/services/notification.service';
import { ResumeAllFormsService } from 'src/app/services/resume-all-forms.service';
import { FormModalConfirmComponent } from 'src/app/shared/form-modal-confirm/form-modal-confirm.component';
import { Cd001CardGuideComponent } from './guideCard/cd001-card-guide.component';
import { Cd001CardLimpezaIComponent } from './partialViews/cd001-card-limpeza-I.component';
import { Cd001CardLimpezaIIComponent } from './partialViews/cd001-card-limpeza-II.component';
import { Cd001CardLimpezaIIIComponent } from './partialViews/cd001-card-limpeza-III.component';
import { Cd001CardLimpezaIVComponent } from './partialViews/cd001-card-limpeza-IV.component';
import { Cd001CardLimpezaVComponent } from './partialViews/cd001-card-limpeza-V.component';

@Component({
  selector: 'app-form-cd001-limpeza',
  templateUrl: './form-cd001-limpeza.component.html',
})
export class FormCd001LimpezaComponent implements OnInit, AfterViewInit {
  public header?: CabecalhoDTO;
  public formulario?: FormGroup;
  public btnCollapse?: boolean;
  private loadingSubject = new BehaviorSubject<boolean>(false);
  public enableButtons = this.loadingSubject.asObservable();
  public formCd001: FormCd001Limpeza = new FormCd001Limpeza();
  public areaSelect: string = localStorage.getItem('area-select') || null
  valuesInitial: any;
  valoresAlterados: any[] = [];
  currentUser: string = "";

  @ViewChild(Cd001CardLimpezaIComponent, { static: false })
  cd001CardLimpezaIComponent: Cd001CardLimpezaIComponent;
  @ViewChild(Cd001CardLimpezaIIComponent, { static: false })
  cd001CardLimpezaIIComponent: Cd001CardLimpezaIIComponent;
  @ViewChild(Cd001CardLimpezaIIIComponent, { static: false })
  cd001CardLimpezaIIIComponent: Cd001CardLimpezaIIIComponent;
  @ViewChild(Cd001CardLimpezaIVComponent, { static: false })
  cd001CardLimpezaIVComponent: Cd001CardLimpezaIVComponent;
  @ViewChild(Cd001CardLimpezaVComponent, { static: false })
  cd001CardLimpezaVComponent: Cd001CardLimpezaVComponent;

  // tslint:disable-next-line: max-line-length
  constructor(
    protected formBuilder: FormBuilder,
    protected generalService: GeneralService,
    protected notificationService: NotificationService,
    protected formularioService: FormularioService,
    protected route: ActivatedRoute,
    protected resumeAllFormsService: ResumeAllFormsService,
    public dialog: MatDialog
  ) {
    this.header = new CabecalhoDTO();
    this.formulario = this.formCd001.createFormLimpeza(formBuilder);
  }

  ngAfterViewInit(): void {
    this.route.data.subscribe(async (data: any) => {
      if (!!data) {
        this.valuesInitial = data?.formulario ?? this.formulario.getRawValue();;
        const type = this.route?.snapshot?.params?.type;
        const isReadOnly: boolean = type === '2' ? true : false;
        this.loadingSubject.next(isReadOnly ? false : true);
        if (type === '1' || type === '2') {
          if (type === '1') {
            this.header = this.generalService.createHeader(
              EnumForm.FormCd001PreLimpeza,
              EnumFormType.Edit
            );
          } else {
            this.header = this.generalService.createHeader(
              EnumForm.FormCd001PreLimpeza,
              EnumFormType.Details
            );
          }
          await this.updateForm(data);
        } else {

          this.header = this.generalService.createHeader(
            EnumForm.FormCd001PreLimpeza,
            EnumFormType.New
          );
          await this.getUser();
          this.fillCreatedByFormField();
          this.cd001CardLimpezaIComponent.formulario
            .get('site')
            .setValue(this.generalService.getLocalStorageDataSite());
        }
      }
    });
  }

  ngOnInit(): void {
    this.header = this.generalService.createHeader(
      EnumForm.FormCd001PreLimpeza,
      EnumFormType.New
    );
    this.btnCollapse = true;
    this.loadingSubject.next(false);
  }

  async save(): Promise<void> {
    console.log(this.formulario.getRawValue())
    const id: number = this.formulario.get('id').value as number;
    const isAddFlow = id === 0;
    if ((await this.validFormsToSave()) !== '') {
      return
      // await this.formularioService.saveForm(
      //   id,
      //   this.formulario.getRawValue(),
      //   'cd001_prelimpeza',
      //   await this.getRouter()
      // );
      // await this.openDialog();
    }

    await this.buildFormulario();
    this.resumeAllFormsService.compareAdd(this.valuesInitial, this.formulario.getRawValue(), isAddFlow, 'cd001_prelimpeza');
    // CHAMAR MODAL DE CONFIRMACAO
    this.openConfirmDialog(this.resumeAllFormsService.valoresAlterados, isAddFlow);

    // await this.formularioService.saveForm(id, this.formulario.getRawValue(), 'cd001_prelimpeza',
    //   await this.getRouter());
    // await this.openDialog();




  }




  public async openConfirmDialog(valoresAlterados: any[], isAddFlow): Promise<void> {

    const values: any[] = valoresAlterados;

    const dialogRef = this.dialog.open(FormModalConfirmComponent, {
      data: {
        valoresAlterados: values,
        isAddFlow

      }

    });
    dialogRef.afterClosed().subscribe(x => {
      if (x.save) {
        const id: number = this.formulario.get('id').value as number;
        this.formularioService.saveForm(id, this.formulario.getRawValue(), 'cd001_prelimpeza', this.areaSelect.includes('Básica') ? 'formcd001/Básica/limpeza' : 'formcd001/Comercial/limpeza');
        this.openDialog();
      } else {
        this.resumeAllFormsService.valoresAlterados = [];
      }


    })






  }

  async getForms(): Promise<FormGroup[]> {
    const arrForms: Array<FormGroup> = new Array<FormGroup>();
    arrForms.push(this.cd001CardLimpezaIComponent.formulario);
    arrForms.push(this.cd001CardLimpezaIIComponent.formulario);
    arrForms.push(this.cd001CardLimpezaIIIComponent.formulario);
    arrForms.push(this.cd001CardLimpezaIVComponent.formulario);
    arrForms.push(this.cd001CardLimpezaVComponent.formulario);
    return await arrForms;
  }

  async validFormsToSave(): Promise<string> {
    return await this.formularioService.validForm(await this.getForms());
  }

  async cleanAll(): Promise<void> {
    if (
      this.header.ScreenType ===
      this.generalService.getEnumFormType(EnumFormType.New)
    ) {
      await this.formularioService.cleanForm(await this.getForms());
      await this.getUser();
      this.cd001CardLimpezaIComponent.formulario
        .get('site')
        .setValue(this.generalService.getLocalStorageDataSite());
    } else {
      const usuario: string =
        this.cd001CardLimpezaIIIComponent.formulario.get('usuario')?.value;
      await this.formularioService.cleanForm(await this.getForms());
      this.cd001CardLimpezaIIIComponent.formulario
        .get('usuario')
        ?.setValue(usuario);
    }
  }

  async collapseAll(): Promise<void> {
    this.btnCollapse = this.btnCollapse ? false : true;
    this.cd001CardLimpezaIComponent.collapseCard = this.btnCollapse
      ? false
      : true;
    this.cd001CardLimpezaIIComponent.collapseCard = this.btnCollapse
      ? false
      : true;
    this.cd001CardLimpezaIIIComponent.collapseCard = this.btnCollapse
      ? false
      : true;
    this.cd001CardLimpezaIVComponent.collapseCard = this.btnCollapse
      ? false
      : true;
    this.cd001CardLimpezaVComponent.collapseCard = this.btnCollapse
      ? false
      : true;
  }

  public async buildFormulario(): Promise<void> {
    this.formulario = await this.formCd001.buildForm(
      this.formulario,
      await this.getForms(),
      this.generalService
    );
    console.log(this.formulario);

  }

  public async updateForm(data?: any): Promise<void> {
    console.log(data)
    this.formulario.get('id').setValue(data.formulario.id);
    await this.formCd001.updateForm(
      data,
      await this.getForms(),
      this.generalService
    );
  }

  public async makeCalculations(event?: any): Promise<void> {
    await this.calcVazaoProcesso();
    await this.calcDescarteTotalPreLimpeza();
    await this.calcPerdaSementeBoaDescarte();
    await this.calcPerdaDescartePorc();
    await this.calcTotalDefeitosPorc();
    await this.calcDiferencaPesoHectolitrico();
    await this.calcDescarteKgH();
  }

  public async calcVazaoProcesso(): Promise<void> {
    // tslint:disable-next-line: max-line-length
    const pesoAmostraDezSegundos =
      this.cd001CardLimpezaIIComponent.formulario.get(
        'peso_amostra_dez_segundos_kg'
      )?.value as number;
    const pesoAmostraCinSegundos =
      this.cd001CardLimpezaIIComponent.formulario.get(
        'peso_amostra_cinco_segundos_kg'
      )?.value as number;
    let resultado = null
    if (this.areaSelect.includes('Básica')) {
      resultado = (pesoAmostraCinSegundos * (3600 / 5) / 1000);
    }
    else {
      resultado = (pesoAmostraDezSegundos * 6 * 60) / 1000;

    }
    this.cd001CardLimpezaIIComponent.formulario
      .get('vazao_processo_th')
      .setValue(resultado);
  }

  public async calcDescarteTotalPreLimpeza(): Promise<void> {
    // tslint:disable-next-line: max-line-length
    const pesoAmostraTrintaSegundos =
      this.cd001CardLimpezaIIIComponent.formulario.get(
        'peso_amostra_trinta_segundos_g'
      )?.value as number;
    const vazaoProcesso = this.cd001CardLimpezaIIComponent.formulario.get(
      'vazao_processo_th'
    )?.value as number;
    let resultado = 0;
    if (vazaoProcesso > 0) {
      if (this.areaSelect.includes('Básica')) {

        const pesoPesoPreSuccao =
          this.cd001CardLimpezaIIIComponent.formulario.get(
            'peso_pre_pos_succsao'
          )?.value as number;
        const pesoTopFundoTrintaSeg =
          this.cd001CardLimpezaIIIComponent.formulario.get(
            'peso_topo_fundo_30s'
          )?.value as number;
        const descarteResult = ((pesoPesoPreSuccao * (3600 / 60)) / 1000) + ((pesoTopFundoTrintaSeg * (3600 / 30)) / 1000)
        resultado = descarteResult / (descarteResult + vazaoProcesso * 1000) * 100


      }
      else {

        resultado = this.generalService.CalcPorc(
          (pesoAmostraTrintaSegundos * 2 * 60) / 1000000,
          vazaoProcesso
        );

      }
    }


    this.cd001CardLimpezaIIIComponent.formulario
      .get('descarte_total_pre_limpeza_prc')
      .setValue(resultado);
  }

  public async calcPerdaSementeBoaDescarte(): Promise<void> {
    // tslint:disable-next-line: max-line-length
    const descarteTotalPreLimpeza =
      this.cd001CardLimpezaIIIComponent.formulario.get(
        'descarte_total_pre_limpeza_prc'
      )?.value as number;
    const perdaDescarte = this.cd001CardLimpezaIIIComponent.formulario.get(
      'perda_descarte_prc'
    )?.value as number;
    let resultado =
      this.generalService.roundValue(descarteTotalPreLimpeza) *
      this.generalService.roundValue(perdaDescarte);
    resultado = resultado / 100;
    this.cd001CardLimpezaIIIComponent.formulario
      .get('perda_semente_boa_descarte_prc')
      .setValue(resultado);
  }

  public async calcPerdaDescartePorc(): Promise<void> {
    // tslint:disable-next-line: max-line-length
    const pesoSementeBoaDescarte =
      this.cd001CardLimpezaIIIComponent.formulario.get(
        'peso_semente_boa_descarte_g'
      )?.value as number;
    const pesoFracaoAnalise = this.cd001CardLimpezaIIIComponent.formulario.get(
      'peso_fracao_analise_g'
    )?.value as number;
    let resultado = 0;
    if (pesoFracaoAnalise > 0) {
      resultado = this.generalService.CalcPorc(
        pesoSementeBoaDescarte,
        pesoFracaoAnalise
      );
    }
    this.cd001CardLimpezaIIIComponent.formulario
      .get('perda_descarte_prc')
      .setValue(resultado);
  }

  public async calcTotalDefeitosPorc(): Promise<void> {
    // tslint:disable-next-line: max-line-length
    const totalDefeitos = this.cd001CardLimpezaIVComponent.formulario.get(
      'total_defeitos_g'
    )?.value as number;
    const resultado = this.generalService.CalcPorc(totalDefeitos, 100);
    this.cd001CardLimpezaIVComponent.formulario
      .get('total_defeitos_prc')
      .setValue(resultado);
  }

  public async calcDiferencaPesoHectolitrico(): Promise<void> {
    // tslint:disable-next-line: max-line-length
    const pesoFracaoBoa = this.cd001CardLimpezaIVComponent.formulario.get(
      'peso_hectolitrico_fracao_boa'
    )?.value as number;
    const pesoFracaoDescarte = this.cd001CardLimpezaIVComponent.formulario.get(
      'peso_hectolitrico_fracao_descarte'
    )?.value as number;
    let resultado = 0;
    let resultadoAsPercentage = 0;
    if (pesoFracaoBoa > 0) {
      resultado = (pesoFracaoBoa - pesoFracaoDescarte) / pesoFracaoBoa;
      resultadoAsPercentage = resultado * 100;
    }
    if (this.areaSelect.includes('Básica')) {
      let resultadoTxt = "";
      if (resultado < 0.05) {
        resultadoTxt = "Sementes boas no descarte"
      }
      else if (resultado > 0.12) {
        resultadoTxt = "Descarte na massa boa"
      }
      else {
        resultadoTxt = "Descarte esperado"
      }
      this.cd001CardLimpezaIVComponent.formulario
        .get('resultado')
        .setValue(resultadoTxt);
    }
    this.cd001CardLimpezaIVComponent.formulario
      .get('diferenca_peso_hectolitrico')
      .setValue(resultadoAsPercentage);
  }

  calcDescarteKgH = async () => {
    // Regra '=(( "Peso pré + pós-sucção em 60 segundos (g)" * (3600/60) + "Peso topo e fundo em 30 segundos (g)" * (3600/30)) / 1000)


    const pesoPesoPreSuccao =
      this.cd001CardLimpezaIIIComponent.formulario.get(
        'peso_pre_pos_succsao'
      )?.value as number;
    const pesoTopFundoTrintaSeg =
      this.cd001CardLimpezaIIIComponent.formulario.get(
        'peso_topo_fundo_30s'
      )?.value as number;
    const descarteResult = ((pesoPesoPreSuccao * (3600 / 60)) / 1000) + ((pesoTopFundoTrintaSeg * (3600 / 30)) / 1000)
    let calc = descarteResult;
    this.cd001CardLimpezaIIIComponent.formulario
      .get('descarte_kg_h')
      .setValue(calc);
  }

  private async getUser(): Promise<void> {
    await this.formularioService
      .getUser()
      .pipe(take(1))
      .toPromise()
      .then((response) => {

        if (response['user-profile']?.displayName != '' && response['user-profile']?.displayName != null) {
          this.currentUser = response['user-profile']?.displayName;
        }
        else if (response['user-profile']?.fullName != '' && response['user-profile']?.fullName != null) {
          this.currentUser = response['user-profile']?.fullName;
        }
        else {
          this.getUserName();
        }
        this.cd001CardLimpezaVComponent.formulario
          .get('usuario')
          .setValue(this.currentUser);

      })
      .catch(async (error) => {
        this.getUserName();
      });
  }

  private async getUserName(): Promise<void> {
    await this.generalService
      .getUserNameValue()
      .pipe(take(1))
      .toPromise()
      .then((response: string) => {
        this.cd001CardLimpezaVComponent.formulario
          .get('usuario')
          .setValue(response ?? 'Administrador');
        this.currentUser = response;
      })
      .catch((err) => { });
  }

  getRouter = async (): Promise<string> => {
    let router: string;
    await this.route.paramMap.subscribe((paramMap) => {
      router = `formcd001/${paramMap.get('area')}/limpeza`;
    });

    return router;
  };

  backList = async () => {
    this.generalService.goToRoute(await this.getRouter());
  };

  async openDialog(): Promise<void> {
    const presencaSabugoPedunculo = this.cd001CardLimpezaIVComponent.formulario.get('presenca_sabugo_pedunculo')?.value;
    const presencaFundo = this.cd001CardLimpezaIVComponent.formulario.get('presenca_fundo')?.value;
    const presencaPoExcesso = this.cd001CardLimpezaIVComponent.formulario.get('presenca_po_excesso')?.value;
    const diferencaPesoHectolitrico = this.cd001CardLimpezaIVComponent.formulario.get('diferenca_peso_hectolitrico')?.value as number;
    const loteOrigem = this.cd001CardLimpezaIComponent.formulario.get('lote_origem')?.value;

    if (presencaSabugoPedunculo != null
      || presencaFundo != null
      || presencaPoExcesso != null
      || diferencaPesoHectolitrico != null
      || loteOrigem != null) {
      const dialogRef = this.dialog.open(Cd001CardGuideComponent, {
        width: '670px',
        maxHeight: '700px',
        data: {
          presencaSabugoPedunculo: presencaSabugoPedunculo,
          presencaPoExcesso: presencaPoExcesso,
          presencaFundo: presencaFundo,
          diferencaPesoHectolitrico: diferencaPesoHectolitrico,
          loteDs: loteOrigem
        },
      });
    }
  }

  async getPC003Data(data?: any) {
    await this.formularioService.getPc003Data(data.contratoJuridico, data.safra, data.numeroCampo).pipe(take(1)).toPromise().then((objPC003: any) => {


      this.cd001CardLimpezaIComponent.formulario.get('hibrido').setValue(objPC003?.data?.hibrido_rnc);

    }).catch(async (error: HttpErrorResponse) => {
      this.notificationService.showNotificationError(error, `Ocorreu um erro, não foi possivel encontrar o valor de prioridade ou Geração.`);
    });
  }

  private fillCreatedByFormField(): void {
    this.cd001CardLimpezaVComponent.formulario.get('criado_por').setValue(this.currentUser);
  }

}
